import React from "react";
import { Link } from "react-router-dom";

const Privacy = () => {
    return (
        <div data-testid="privacy-page" className="bg-[#FAF9F6] min-h-screen">
            <div className="max-w-3xl mx-auto px-6 lg:px-10 pt-16 pb-24">
                <p className="label">Privacy</p>
                <h1 className="font-serif text-5xl sm:text-6xl mt-5 text-[#1C1C1A] leading-none" data-testid="privacy-heading">
                    Privacy Policy
                </h1>
                <p className="mt-6 text-sm text-[#737562] uppercase tracking-[0.22em]">
                    ALATI &middot; Handmade in Darwin, Australia
                </p>

                <div className="mt-10 space-y-8 text-[#4A4A46] leading-relaxed">
                    <section>
                        <h2 className="font-serif text-2xl text-[#1C1C1A] mb-3">What this page covers</h2>
                        <p>
                            ALATI is a small, family-run workshop. This page explains, in plain
                            language, what information we collect when you use the website and how
                            we look after it. If anything here is unclear, please write to us via
                            the <Link to="/contact" className="alati-link">Contact page</Link>.
                        </p>
                    </section>

                    <section data-testid="privacy-reviews-section">
                        <h2 className="font-serif text-2xl text-[#1C1C1A] mb-3">The Reviews form</h2>
                        <p>
                            When you leave a review on <Link to="/reviews" className="alati-link">/reviews</Link>,
                            or via a bar detail page, we collect the following information:
                        </p>
                        <ul className="mt-4 space-y-2 list-disc list-inside">
                            <li>Your <strong>name</strong> — displayed publicly as your first name and surname initial only (e.g., &ldquo;Jane S.&rdquo;) after approval.</li>
                            <li>Your <strong>email address</strong> — used only to manage your review. Never displayed publicly. Never shared.</li>
                            <li>The <strong>review content</strong> you submit — your title and the words of your review.</li>
                            <li>The <strong>bar</strong> you selected and the <strong>star rating</strong> you gave it.</li>
                            <li>Your <strong>IP address</strong> — recorded automatically for spam prevention and rate limiting. Never displayed publicly.</li>
                        </ul>
                        <p className="mt-4">
                            <strong>Email addresses and IP addresses are never displayed on the public
                            website.</strong> They are visible only to the ALATI moderator in the
                            admin panel and are used for the purposes above.
                        </p>
                        <p className="mt-4">
                            All reviews are moderated before they appear on the site. We may
                            correct obvious typos before publishing. You can request that your
                            review be removed at any time by writing to us via the Contact page.
                        </p>
                    </section>

                    <section>
                        <h2 className="font-serif text-2xl text-[#1C1C1A] mb-3">Orders and checkout</h2>
                        <p>
                            When you place an order, we collect the details required to fulfil it &mdash;
                            your name, shipping address, contact email and the items you have
                            ordered. Payment is processed by Stripe on their secure checkout page;
                            ALATI never sees or stores your card details.
                        </p>
                    </section>

                    <section>
                        <h2 className="font-serif text-2xl text-[#1C1C1A] mb-3">Contact form</h2>
                        <p>
                            Messages sent through the <Link to="/contact" className="alati-link">Contact page</Link>{" "}
                            are stored so we can reply to you. Your details are not used for
                            marketing.
                        </p>
                    </section>

                    <section>
                        <h2 className="font-serif text-2xl text-[#1C1C1A] mb-3">What we do not do</h2>
                        <ul className="mt-2 space-y-2 list-disc list-inside">
                            <li>We do not sell or share your personal information with third parties.</li>
                            <li>We do not run tracking pixels or third-party advertising networks on this site.</li>
                            <li>We do not display customer email addresses or IP addresses anywhere on the public website.</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="font-serif text-2xl text-[#1C1C1A] mb-3">Contact</h2>
                        <p>
                            To request the removal of a review, update your details, or ask any
                            question about how your information is handled, please write to us
                            via <Link to="/contact" className="alati-link">/contact</Link>. We will
                            respond personally.
                        </p>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default Privacy;
